import { ADD_SHIPMENT_LABEL_SUCCESS, ADD_SHIPMENT_LABEL_REQUEST, ADD_SHIPMENT_LABEL_FAILURE, ADD_SHIPMENT_LABEL_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const addShipmentLabelReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SHIPMENT_LABEL_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case ADD_SHIPMENT_LABEL_REQUEST:
            return Object.assign({}, state);
        case ADD_SHIPMENT_LABEL_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case ADD_SHIPMENT_LABEL_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default addShipmentLabelReducer;
